module.exports = __webpack_public_path__ + "account/assets/course.032e8f66.svg";